import { required, optional } from "AppReact/schema";

export default {
  account_id: optional('number'),
  actual_move_out: optional('jsDate'),
  autopay: optional('boolean'),
  bounce_id: optional('number'),
  email: optional('string'),
  eviction: optional('string'),
  id: optional('number'),
  last_login: optional('jsDate'),
  name: optional('string'),
  notice_date: optional('jsDate'),
  property_name: optional('string'),
  start_date: optional('jsDate'),
  unit: optional('string'),
};
